import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Tab as MuiTab } from '@mui/material';
import { Link } from 'react-router-dom';

// Component scope - Constants and static data
const ICON_POSITIONS = ['start', 'end', 'top', 'bottom'];

/**
 * App Link Tab Component - Wrapper for MUI Tab with link functionality
 * @component
 * @param {Object} props - Component props
 * @returns {React.ReactElement} AppLinkTabComponent
 */
const AppLinkTabComponent = memo(({ 
  label, 
  icon, 
  href, 
  iconPosition = 'start', 
  selected = false,
  ...props 
}) => {
  // Return/rendering
  return (
    <MuiTab
      component={Link}
      label={label}
      icon={icon}
      iconPosition={iconPosition}
      to={href}
      aria-current={selected ? 'page' : undefined}
      {...props}
    />
  );
});

AppLinkTabComponent.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.node,
  href: PropTypes.string.isRequired,
  iconPosition: PropTypes.oneOf(ICON_POSITIONS),
  selected: PropTypes.bool,
  sx: PropTypes.object,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

AppLinkTabComponent.displayName = 'AppLinkTabComponent';

export default AppLinkTabComponent;
